import LocalizationLookup from './LocalizationLookup';

export default LocalizationLookup;